import React from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { RoundedImage, RecordTableCell, HeaderTypography } from '../../utilComponents/StyledComponents';

const Constants = require("../../constants/Constants");
let MAPS = Constants.MAPS;
let CHARACTERS = Constants.CHARACTERS;
let IMAGE_URL = Constants.IMAGE_URL;

const GrandPrixRaces = ({ raceRecords }) => {
    const colors = [
        "#8EE9FF",
        "#FF8E8E",
        "#FFFF8E",
        "#8EFF8F"
    ];

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            {raceRecords.map((race, raceIndex) => (
                <TableContainer
                    key={`${race.courseId}-${raceIndex}`}
                    sx={{
                        mb: 2,
                        backgroundColor: colors[raceIndex % colors.length], // Alternate colors based on index
                        borderRadius: 2,
                        border: 4,
                        maxWidth: '600px',
                        width: "95%",
                        mx: 'auto', // Center horizontally
                    }}
                >
                    <Table
                        sx={{
                            tableLayout: 'fixed',
                            '& .MuiTableCell-root': {
                                padding: '4px',
                                fontSize: {
                                    xs: '0.6rem',
                                    sm: '0.75rem',
                                    md: '0.875rem',
                                },
                            },
                        }}
                        size="small"
                    >
                        {/* Title Row with Course and Image */}
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={3} sx={{ paddingBottom: 0 }}>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', p: 1 }}>
                                        <Typography sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '.75rem', color: 'black',  mr: 2 }}>
                                            {raceIndex + 1}.
                                        </Typography>
                                        <Typography sx={{ fontFamily: '"Press Start 2P", sans-serif', fontWeight: 'bold', fontSize: '.75rem', color: 'black', overflowWrap: 'break-word', wordWrap: 'break-word', mr: 2 }}>
                                            {race.course}
                                        </Typography>
                                        <img
                                            src={`${IMAGE_URL}${MAPS[race.cupId - 1]?.races[(race.courseId - 1) % 4]?.mapImage}`}
                                            alt={race.course}
                                            style={{ width: '40%', height: '40%', maxWidth: '100px' }}
                                        />
                                    </Box>
                                </TableCell>
                            </TableRow>

                            {/* Column Headers */}
                            <TableRow>
                                <TableCell align="center" sx={{ width: '10%' }}>
                                    <HeaderTypography headerName="Place" sx={{ blackSpace: 'nowrap', color: 'black' }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '45%' }}>
                                    <HeaderTypography headerName="Player" sx={{ blackSpace: 'nowrap', color: 'black' }} />
                                </TableCell>
                                <TableCell align="center" sx={{ width: '45%' }}>
                                    <HeaderTypography headerName="Character" sx={{ blackSpace: 'nowrap', color: 'black' }} />
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {race.racePlayers
                                .sort((a, b) => a.place - b.place) // Sort players by their place value
                                .map((player) => (
                                    <TableRow key={player.playerId}>
                                        <RecordTableCell
                                            backgroundColor={colors[raceIndex % colors.length]}
                                            recordValue={player.place} // Use the place value from the player
                                            sx={{ color: 'black' }}
                                        />
                                        <RecordTableCell
                                            backgroundColor={colors[raceIndex % colors.length]}
                                            recordValue={`${player.firstName} ${player.lastName}`}
                                            sx={{ color: 'black' }}
                                        />
                                        <TableCell align="center" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <RoundedImage
                                                src={`${IMAGE_URL}${CHARACTERS[parseInt(player.characterId) - 1]['rosterUrl']}`}
                                                alt={player.character}
                                                sx={{ width: '30%', height: '30%', maxWidth: '50px' }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ))}
        </Box>
    );
};

export default GrandPrixRaces;
